var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelemedicine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68397 7.90575L5.66397 5.92575C5.86068 5.72575 5.99982 5.47641 6.06674 5.20398C6.13366 4.93156 6.12588 4.64613 6.04422 4.37775C5.90547 3.92122 5.78289 3.45994 5.67672 2.99475C5.58972 2.5875 5.23197 2.25 4.81497 2.25H3.68397C2.85147 2.25 2.16672 2.928 2.25822 3.756C2.95272 10.05 7.95072 15.0473 14.244 15.7418C15.072 15.8333 15.75 15.1493 15.75 14.3168V13.1843C15.75 12.7688 15.411 12.4267 15.0015 12.3517C14.5514 12.2642 14.107 12.1493 13.671 12.0075C13.0957 11.8245 12.4567 11.9535 12.03 12.3795L10.0942 14.316",
    stroke: "#3F3F3F",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemedicine);
export default __webpack_public_path__ + "static/media/telemedicine.af338a361ce81eb55f3059435650c7e3.svg";
export { ForwardRef as ReactComponent };